import { html, type TemplateResult } from 'lit-html';

export function when(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export function ago(iso: string | null | undefined): string {
  if (!iso) return '—';
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return `${Math.round(s / 86400)}d ago`;
}

export function duration(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return '—';
  const s = Math.round(Number(seconds));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
}

export function pct(v: string | number | null | undefined): string {
  if (v === null || v === undefined) return '—';
  return `${(Number(v) * 100).toFixed(1)}%`;
}

const STATUS_TONE: Record<string, string> = {
  deactivated: 'accent',
  already_inactive: 'accent',
  reactivated: 'positive',
  dry_run: 'info',
  detected: 'neutral',
  deactivation_pending: 'warning',
  grace_warning: 'warning',
  failed: 'critical',
  unconfirmed: 'critical',
  expired: 'neutral',
  ignored_queue: 'neutral',
  exempt_agent: 'neutral',
  outside_hours: 'neutral',
  coalesced: 'neutral',
  not_member: 'neutral',
  queue_missing: 'neutral',
  membership_removed: 'neutral',
};

export const STATUS_LABEL: Record<string, string> = {
  deactivated: 'Deactivated',
  already_inactive: 'Already inactive',
  reactivated: 'Reactivated',
  dry_run: 'Dry run',
  detected: 'Recorded',
  deactivation_pending: 'Pending',
  grace_warning: 'Grace warning',
  failed: 'Failed',
  unconfirmed: 'Unconfirmed',
  expired: 'Expired',
  ignored_queue: 'Queue not enforced',
  exempt_agent: 'Exempt agent',
  outside_hours: 'Outside hours',
  coalesced: 'Same incident',
  not_member: 'Not a member',
  queue_missing: 'Queue missing',
  membership_removed: 'Removed from queue',
};

export function statusPill(status: string): TemplateResult {
  return html`<span class="pill ${STATUS_TONE[status] ?? 'neutral'}">${STATUS_LABEL[status] ?? status}</span>`;
}

export function pill(text: string, tone = 'neutral'): TemplateResult {
  return html`<span class="pill ${tone}">${text}</span>`;
}
